// PE-438: tiny shared formatters for the appointment statistics dashboard.

// Locale-aware thousands formatting ("57.412" in id, "57,412" in en).
export function formatNumber(value, locale, options) {
  const num = Number(value);
  if (!Number.isFinite(num)) return value === null || value === undefined ? '-' : String(value);
  return num.toLocaleString(locale === 'id' ? 'id-ID' : 'en-US', options);
}

// Local-timezone YYYY-MM-DD (toISOString would shift the day around midnight).
export function isoDate(date) {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

// Fills Rails-style %{key} placeholders in a label that crossed as a prop.
export function interpolate(template, values) {
  return String(template || '').replace(/%\{(\w+)\}/g, (match, key) => (
    values && values[key] !== undefined ? values[key] : match
  ));
}
